export const arrayOfObjects = [
  {
    DateTime: '2023-03-18 12:00:00',
    Name: 'Train_Speed',
    Value: 73,
    Description: 'Train Speed Description',
    status: 'high',
    statusValue: '10215/45664'
  },
  {
    DateTime: '2023-03-18 13:00:00',
    Name: 'Train_Speed1',
    Value: 20,
    Description: 'Train Speed Description1'
  },
  {
    DateTime: '2023-03-18 12:00:00',
    Name: 'Train_Speed',
    Value: 93,
    Description: 'Train Speed Description'
  },
  {
    DateTime: '2023-03-18 13:00:00',
    Name: 'Train_Speed1',
    Value: 40,
    Description: 'Train Speed Description1'
  }
];
export const objectOfObject = {
  query: [
    {
      DateTime: '2022-10-18 04:42:21+00',
      Name: 'Train_Speed',
      Value: 73,
      Description: 'Train Speed Description'
    }
  ],
  query1: [
    {
      DateTime: '2022-10-18 04:42:21+00',
      Name: 'Train_Speed',
      Value: 73,
      Description: 'Train Speed Description'
    }
  ]
};

export const LineTabCounMock = {
  counter: [
    {
      DateTime: '2022-10-18 04:42:21+00',
      Name: 'Train_Speed',
      Value: 73,
      Description: 'Train Speed Description'
    }
  ],
  table: [
    {
      DateTime: '2022-10-18 04:42:21+00',
      Name: 'Train_Speed',
      Value: 73,
      Description: 'Train Speed Description'
    }
  ]
};

export const ArrayOfObjectsWithAction = [
  {
    DateTime: '2022-10-20 10:40:20+00',
    Name: 'MR_Pressure',
    Value: 8.947,
    Description: 'MR Pressure description',
    Action: [
      {
        DateTime: '2022-10-20 10:40:20+00',
        Name: 'MR_Pressure1',
        Value: 8.947,
        Description: 'MR Pressure description1'
      }
    ]
  },
  {
    DateTime: '2022-10-20 10:40:20+00',
    Name: 'Train_Speed',
    Value: 66,
    Description: 'Train Speed description',
    Action: []
  },
  {
    DateTime: '2022-10-20 10:40:20+00',
    Name: 'Running_KM',
    Value: 166,
    Description: 'Running KM description',
    Action: []
  }
];
export const image = [
  {
    Image:
      'data:image/jpeg;base64,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'
  }
];

export const DonutCounterMock = {
  query: [
    {
      DateTime: '2022-10-18 04:42:21+00',
      Name: 'Total Alerts',
      Value: 73,
      Description: 'Train Speed Description'
    },
    {
      DateTime: '2022-10-18 04:42:21+00',
      Name: 'Active Alerts',
      Value: 20,
      Description: 'Train Speed Description1'
    }
  ],
  query1: [
    {
      Name: 'Total Alerts',
      Value: 73,
      Description: 'Total Alerts'
    },
    {
      Name: 'Active Alerts',
      Value: 20,
      Description: 'Active Alerts'
    }
  ]
};

export const videoMock = [
  {
    id: 1,
    category: 'fruits',
    imageUrl:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTeZeDQSmW4Nt9OH-zV4XSxOoS1GPPzD3wkAw&usqp=CAU',
    videoUrl: 'https://icedrive.net/s/NFvRu9597CVYx9uigNG2jTufyhwA'
  },
  {
    id: 2,
    category: 'fruits',
    imageUrl: 'http://placeimg.com/800/1200/nature'
  },
  {
    id: 3,
    category: 'fruits',
    imageUrl: 'http://placeimg.com/1920/1080/nature'
  },
  {
    id: 4,
    category: 'vegetables',
    imageUrl: 'http://placeimg.com/1500/500/nature'
  }
];

export const barMockJson = [
  {
    interval_alias: '2021-06-25 11:12:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:12:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:12:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:13:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:13:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:13:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:14:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:14:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:14:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:15:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:15:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:15:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:16:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:16:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:16:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:17:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:17:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:17:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:18:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:18:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:18:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:19:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:19:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:19:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:20:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:20:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:20:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:21:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:21:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:21:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:22:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:22:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:22:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:23:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:23:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:23:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:24:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:24:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:24:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:25:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:25:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:25:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:26:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:26:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:26:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:27:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:27:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:27:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:28:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:28:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:28:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:29:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:29:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:29:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:30:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:30:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:30:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:31:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:31:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:31:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:32:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:32:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:32:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:33:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:33:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:33:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:34:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:34:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:34:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:35:15',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:35:15',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:35:15',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:36:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:36:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:36:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:37:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:37:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:37:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:38:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:38:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:38:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:39:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:39:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:39:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:40:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:40:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:40:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  },
  {
    interval_alias: '2021-06-25 11:41:14',
    Name: 'Conductivity',
    Value: 0.29,
    tag_description: 'Conductivity (S/m)'
  },
  {
    interval_alias: '2021-06-25 11:41:14',
    Name: 'Salinity',
    Value: 0.29,
    tag_description: 'Salinity (PSU)'
  },
  {
    interval_alias: '2021-06-25 11:41:14',
    Name: 'Temperature_of_water',
    Value: 29,
    tag_description: 'Temperature of water (DegC)'
  }
];
export const barTableMockJson = [
  {
    wqr: 'MDB-12',
    Name: 'Active_Energy_Delivered_Into_Load',
    Value: 14988,
    tag_description: 'MDB Energy Meters',
    Action: [
      {
        'S.No': '1',
        locationName: 'MDB-12',
        value: 14988,
        impact: '-1.75 %',
        severity: 'Low'
      }
    ]
  },
  {
    interval_alias: 'Line#02 Polishing#02',
    Name: 'Active_Energy_Delivered_Into_Load',
    Value: 3212.4,
    tag_description: 'MDB Energy Meters',
    anomalyList: [
      {
        'S.No': '1',
        locationName: 'Line#02 Polishing#02',
        value: 3212.4,
        impact: '1.57 %',
        severity: 'High'
      }
    ]
  },
  {
    interval_alias: 'Line#02 Polishing#01',
    Name: 'Active_Energy_Delivered_Into_Load',
    Value: 2363,
    tag_description: 'MDB Energy Meters',
    anomalyList: [
      {
        'S.No': '1',
        locationName: 'Line#02 Polishing#01',
        value: 2363,
        impact: '2.14 %',
        severity: 'High'
      }
    ]
  },
  {
    interval_alias: 'Line#02 Final squaring',
    Name: 'Active_Energy_Delivered_Into_Load',
    Value: 2252.7,
    tag_description: 'MDB Energy Meters',
    anomalyList: [
      {
        'S.No': '1',
        locationName: 'Line#02 Final squaring',
        value: 2252.7,
        impact: '-10.20 %',
        severity: 'Low'
      }
    ]
  },
  {
    interval_alias: 'Line#02 Calibration#03',
    Name: 'Active_Energy_Delivered_Into_Load',
    Value: 1223.4,
    tag_description: 'MDB Energy Meters',
    anomalyList: [
      {
        'S.No': '1',
        locationName: 'Line#02 Calibration#03',
        value: 1223.4,
        impact: '-1.26 %',
        severity: 'Low'
      }
    ]
  },
  {
    interval_alias: 'Line#02 Calibration#04',
    Name: 'Active_Energy_Delivered_Into_Load',
    Value: 1068.6,
    tag_description: 'MDB Energy Meters',
    anomalyList: [
      {
        'S.No': '1',
        locationName: 'Line#02 Calibration#04',
        value: 1068.6,
        impact: '13.87 %',
        severity: 'High'
      }
    ]
  },
  {
    interval_alias: 'Line#02 Calibration#01',
    Name: 'Active_Energy_Delivered_Into_Load',
    Value: 1030.8,
    tag_description: 'MDB Energy Meters',
    anomalyList: [
      {
        'S.No': '1',
        locationName: 'Line#02 Calibration#01',
        value: 1030.8,
        impact: '13.42 %',
        severity: 'High'
      }
    ]
  },
  {
    interval_alias: 'Line#02 Calibration#02',
    Name: 'Active_Energy_Delivered_Into_Load',
    Value: 810.9,
    tag_description: 'MDB Energy Meters',
    anomalyList: [
      {
        'S.No': '1',
        locationName: 'Line#02 Calibration#02',
        value: 810.9,
        impact: '-15.94 %',
        severity: 'Low'
      }
    ]
  },
  {
    interval_alias: 'Line#02 Sorting',
    Name: 'Active_Energy_Delivered_Into_Load',
    Value: 458.9,
    tag_description: 'MDB Energy Meters',
    anomalyList: [
      {
        'S.No': '1',
        locationName: 'Line#02 Sorting',
        value: 458.9,
        impact: '1.10 %',
        severity: 'High'
      }
    ]
  },
  {
    interval_alias: 'Line#02 Nano Polishing#01',
    Name: 'Active_Energy_Delivered_Into_Load',
    Value: 86,
    tag_description: 'MDB Energy Meters',
    anomalyList: [
      {
        'S.No': '1',
        locationName: 'Line#02 Nano Polishing#01',
        value: 86,
        impact: '-0.46 %',
        severity: 'Low'
      }
    ]
  },
  {
    interval_alias: 'Line#02 Pre Squaring',
    Name: 'Active_Energy_Delivered_Into_Load',
    Value: 72.9,
    tag_description: 'MDB Energy Meters',
    anomalyList: [
      {
        'S.No': '1',
        locationName: 'Line#02 Pre Squaring',
        value: 72.9,
        impact: '-2.67 %',
        severity: 'Low'
      }
    ]
  },
  {
    interval_alias: 'Line#02 Polishing#03',
    Name: 'Active_Energy_Delivered_Into_Load',
    Value: 57.6,
    tag_description: 'MDB Energy Meters',
    anomalyList: [
      {
        'S.No': '1',
        locationName: 'Line#02 Polishing#03',
        value: 57.6,
        impact: '-0.86 %',
        severity: 'Low'
      }
    ]
  },
  {
    interval_alias: 'Line#02 Nano Polishing#02',
    Name: 'Active_Energy_Delivered_Into_Load',
    Value: 22.2,
    tag_description: 'MDB Energy Meters',
    anomalyList: [
      {
        'S.No': '1',
        locationName: 'Line#02 Nano Polishing#02',
        value: 22.2,
        impact: '0.91 %',
        severity: 'High'
      }
    ]
  }
];
export const beijingChartMockJson = [
  {
    interval_alias: '2020-05-05T00:10:00.000Z',
    Value: '350',
    tag_description: 'VelPkXP',
    Name: 'VelPkXP'
  },
  {
    interval_alias: '2020-05-05T00:10:10.000Z',
    Value: '300',
    tag_description: 'VelPkXP',
    Name: 'VelPkXP'
  },
  {
    interval_alias: '2020-05-05T00:10:20.000Z',
    Value: '250',
    tag_description: 'VelPkXP',
    Name: 'VelPkXP'
  },
  {
    interval_alias: '2020-05-05T00:10:30.000Z',
    Value: '200',
    tag_description: 'VelPkXP',
    Name: 'VelPkXP'
  },
  {
    interval_alias: '2020-05-05T00:10:40.000Z',
    Value: '150',
    tag_description: 'VelPkXP',
    Name: 'VelPkXP'
  },
  {
    interval_alias: '2020-05-05T00:10:55.000Z',
    Value: '100',
    tag_description: 'VelPkXP',
    Name: 'VelPkXP'
  },
  {
    interval_alias: '2020-05-05T00:11:00.000Z',
    Value: '50',
    tag_description: 'VelPkXP',
    Name: 'VelPkXP'
  }
];
export const confusionMatrixMockJson = [
  [0, 0, 477],
  [1, 0, 34],
  [0, 1, 6],
  [1, 1, 0.9]
];
export const boxPlotMockJson = [
  [
    850, 740, 900, 1070, 930, 850, 950, 980, 980, 880, 1000, 980, 930, 650, 760, 810, 1000, 1000,
    960, 960
  ],
  [
    960, 940, 960, 940, 880, 800, 850, 880, 900, 840, 830, 790, 810, 880, 880, 830, 800, 790, 760,
    800
  ]
];
export const bubbleChartMockJson = [
  [
    [28604, 77, 17096869, 'Australia', 1990],
    [31163, 77.4, 27662440, 'Canada', 1990],
    [1516, 68, 1154605773, 'China', 1990],
    [13670, 74.7, 10582082, 'Cuba', 1990],
    [28599, 75, 4986705, 'Finland', 1990],
    [29476, 77.1, 56943299, 'France', 1990],
    [31476, 75.4, 78958237, 'Germany', 1990],
    [28666, 78.1, 254830, 'Iceland', 1990],
    [1777, 57.7, 870601776, 'India', 1990],
    [29550, 79.1, 122249285, 'Japan', 1990],
    [2076, 67.9, 20194354, 'North Korea', 1990],
    [12087, 72, 42972254, 'South Korea', 1990],
    [24021, 75.4, 3397534, 'New Zealand', 1990],
    [43296, 76.8, 4240375, 'Norway', 1990],
    [10088, 70.8, 38195258, 'Poland', 1990],
    [19349, 69.6, 147568552, 'Russia', 1990],
    [10670, 67.3, 53994605, 'Turkey', 1990],
    [26424, 75.7, 57110117, 'United Kingdom', 1990],
    [37062, 75.4, 252847810, 'United States', 1990]
  ],
  [
    [44056, 81.8, 23968973, 'Australia', 2015],
    [43294, 81.7, 35939927, 'Canada', 2015],
    [13334, 76.9, 1376048943, 'China', 2015],
    [21291, 78.5, 11389562, 'Cuba', 2015],
    [38923, 80.8, 5503457, 'Finland', 2015],
    [37599, 81.9, 64395345, 'France', 2015],
    [44053, 81.1, 80688545, 'Germany', 2015],
    [42182, 82.8, 329425, 'Iceland', 2015],
    [5903, 66.8, 1311050527, 'India', 2015],
    [36162, 83.5, 126573481, 'Japan', 2015],
    [1390, 71.4, 25155317, 'North Korea', 2015],
    [34644, 80.7, 50293439, 'South Korea', 2015],
    [34186, 80.6, 4528526, 'New Zealand', 2015],
    [64304, 81.6, 5210967, 'Norway', 2015],
    [24787, 77.3, 38611794, 'Poland', 2015],
    [23038, 73.13, 143456918, 'Russia', 2015],
    [19360, 76.5, 78665830, 'Turkey', 2015],
    [38225, 81.4, 64715810, 'United Kingdom', 2015],
    [53354, 79.1, 321773631, 'United States', 2015]
  ]
];
export const CandleStickMockJson = [
  {
    date: '20-01-2020',
    values: [10, 20, 30, 40]
  },
  {
    date: '20-01-2020',
    values: [10, 40, 30, 40]
  }
];
export const candleStickBrushMockJson = [
  ['2004-01-02', 10452.74, 10409.85, 10367.41, 10554.96, 168890000]
];
export const countMock = [
  {
    interval_alias: '2020-05-12T21:49:05.161Z',
    Name: 'TRR_TIC301_PV',
    Value: 395.4,
    tag_description: 'Main stream temperature control'
  }
];
export const cardListMockJson = [
  {
    title: 'Current',
    value: '395.40'
  },
  {
    title: 'Voltage',
    value: '395.50'
  },
  {
    title: 'Watts',
    value: '395.60'
  },
  {
    title: 'Mode of Operation',
    value: '395.40'
  },
  {
    title: 'Illumination(LUX)',
    value: '395.50'
  },
  {
    title: 'Lights status',
    value: '395.60'
  }
];
export const donutMockJson = [
  {
    interval_alias: '2020-04-08 15:31:33',
    Name: 'Bearing In Board',
    Value: 81
  },
  {
    interval_alias: '2020-04-08 15:31:33',
    Name: 'Bearing Out Board',
    Value: 43
  }
];
export const dottedBarMockJson = [
  {
    intervals: [2020, 2021, 2022, 2023, 2024, 2025],
    lineData: {
      tagName: 'EnergyMeterer 1',
      values: [2, 4, 6, 8, 10, 12]
    },
    barData: {
      tagName: 'EnergyMeterer 2',
      values: [1, 2, 3, 4, 5, 6]
    }
  }
];
export const dynamicMock = [];
export const funnelMockJson = [
  {
    interval_alias: '2020-04-08 00:00:03',
    Name: 'Vi_07_fuel_level_perc',
    Value: 90
  },
  {
    interval_alias: '2020-04-08 00:00:03',
    Name: 'Vi_07_Pressure_level_perc',
    Value: 70
  },
  {
    interval_alias: '2020-04-08 00:00:03',
    Name: 'Vi_08_level_perc',
    Value: 60
  },
  {
    interval_alias: '2020-04-08 00:00:03',
    Name: 'Vi_09_level_perc',
    Value: 50
  },
  {
    interval_alias: '2020-04-08 00:00:03',
    Name: 'Vi_10_level_perc',
    Value: 30
  }
];
export const guageMockJson = [
  {
    interval_alias: '2020-05-12T19:29:04.919Z',
    Name: 'TRR_PWC1002_PV',
    Value: 1998,
    tag_description: 'Constant control on generating power'
  }
];
export const guageLineMockJson = {
  query: [
    {
      interval_alias: '2020-09-21 05:46:00',
      Name: 'DWLC_PV',
      Value: '21.88',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:46:00',
      Name: 'ESCTWLC_PV',
      Value: '-7.14',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:47:00',
      Name: 'DWLC_PV',
      Value: '1.58',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:47:00',
      Name: 'ESCTWLC_PV',
      Value: '-4.77',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:48:00',
      Name: 'DWLC_PV',
      Value: '-1.85',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:48:00',
      Name: 'ESCTWLC_PV',
      Value: '-4.08',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:49:00',
      Name: 'DWLC_PV',
      Value: '-1.78',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:49:00',
      Name: 'ESCTWLC_PV',
      Value: '-3.20',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:50:00',
      Name: 'DWLC_PV',
      Value: '1.92',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:50:00',
      Name: 'ESCTWLC_PV',
      Value: '-1.81',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:51:00',
      Name: 'DWLC_PV',
      Value: '4.53',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:51:00',
      Name: 'ESCTWLC_PV',
      Value: '0.06',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:52:00',
      Name: 'DWLC_PV',
      Value: '4.00',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:52:00',
      Name: 'ESCTWLC_PV',
      Value: '0.83',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:53:00',
      Name: 'DWLC_PV',
      Value: '2.38',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:53:00',
      Name: 'ESCTWLC_PV',
      Value: '2.33',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:54:00',
      Name: 'DWLC_PV',
      Value: '-2.79',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:54:00',
      Name: 'ESCTWLC_PV',
      Value: '3.87',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:55:00',
      Name: 'DWLC_PV',
      Value: '-6.66',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:55:00',
      Name: 'ESCTWLC_PV',
      Value: '4.71',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:56:00',
      Name: 'DWLC_PV',
      Value: '-4.57',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:56:00',
      Name: 'ESCTWLC_PV',
      Value: '20.63',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:57:00',
      Name: 'DWLC_PV',
      Value: '-2.37',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:57:00',
      Name: 'ESCTWLC_PV',
      Value: '25.82',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:58:00',
      Name: 'DWLC_PV',
      Value: '2.88',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:58:00',
      Name: 'ESCTWLC_PV',
      Value: '23.21',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:59:00',
      Name: 'DWLC_PV',
      Value: '7.54',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:59:00',
      Name: 'ESCTWLC_PV',
      Value: '20.35',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 06:00:00',
      Name: 'DWLC_PV',
      Value: '11.68',
      tag_description: 'Deaerator water level control PV'
    }
  ],
  query1: [
    {
      interval_alias: '2020-04-08 00:00:03',
      Name: 'Vi_07_fuel_level_perc',
      Value: 90
    }
  ]
};
export const heatmapCalendarMockJson = [
  {
    intervalAlias: '2021-01-10',
    tagValue: '1000'
  },
  {
    intervalAlias: '2021-02-10',
    tagValue: '2000'
  },
  {
    intervalAlias: '2021-03-10',
    tagValue: '3000'
  },
  {
    intervalAlias: '2021-04-10',
    tagValue: '4000'
  },
  {
    intervalAlias: '2021-05-10',
    tagValue: '5000'
  },
  {
    intervalAlias: '2021-06-10',
    tagValue: '6000'
  },
  {
    intervalAlias: '2021-07-10',
    tagValue: '7000'
  },
  {
    intervalAlias: '2021-08-10',
    tagValue: '8000'
  },
  {
    intervalAlias: '2021-09-10',
    tagValue: '9000'
  },
  {
    intervalAlias: '2021-10-10',
    tagValue: '10000'
  },
  {
    intervalAlias: '2021-11-10',
    tagValue: '5000'
  },
  {
    intervalAlias: '2021-12-10',
    tagValue: '8000'
  }
];
export const heatmapCartesionMockJson = [
  [0, 0, 5],
  [0, 1, 1],
  [0, 2, 0],
  [0, 3, 0],
  [0, 4, 0],
  [0, 5, 0],
  [0, 6, 0],
  [0, 7, 0],
  [0, 8, 0],
  [0, 9, 0],
  [0, 10, 0],
  [0, 11, 2],
  [0, 12, 4],
  [0, 13, 1],
  [0, 14, 1],
  [0, 15, 3],
  [0, 16, 4],
  [0, 17, 6],
  [0, 18, 4],
  [0, 19, 4],
  [0, 20, 3],
  [0, 21, 3],
  [0, 22, 2],
  [0, 23, 5],
  [1, 0, 7],
  [1, 1, 0],
  [1, 2, 0],
  [1, 3, 0],
  [1, 4, 0],
  [1, 5, 0],
  [1, 6, 0],
  [1, 7, 0],
  [1, 8, 0],
  [1, 9, 0],
  [1, 10, 5],
  [1, 11, 2],
  [1, 12, 2],
  [1, 13, 6],
  [1, 14, 9],
  [1, 15, 11],
  [1, 16, 6],
  [1, 17, 7],
  [1, 18, 8],
  [1, 19, 12],
  [1, 20, 5],
  [1, 21, 5],
  [1, 22, 7],
  [1, 23, 2],
  [2, 0, 1],
  [2, 1, 1],
  [2, 2, 0],
  [2, 3, 0],
  [2, 4, 0],
  [2, 5, 0],
  [2, 6, 0],
  [2, 7, 0],
  [2, 8, 0],
  [2, 9, 0],
  [2, 10, 3],
  [2, 11, 2],
  [2, 12, 1],
  [2, 13, 9],
  [2, 14, 8],
  [2, 15, 10],
  [2, 16, 6],
  [2, 17, 5],
  [2, 18, 5],
  [2, 19, 5],
  [2, 20, 7],
  [2, 21, 4],
  [2, 22, 2],
  [2, 23, 4],
  [3, 0, 7],
  [3, 1, 3],
  [3, 2, 0],
  [3, 3, 0],
  [3, 4, 0],
  [3, 5, 0],
  [3, 6, 0],
  [3, 7, 0],
  [3, 8, 1],
  [3, 9, 0],
  [3, 10, 5],
  [3, 11, 4],
  [3, 12, 7],
  [3, 13, 14],
  [3, 14, 13],
  [3, 15, 12],
  [3, 16, 9],
  [3, 17, 5],
  [3, 18, 5],
  [3, 19, 10],
  [3, 20, 6],
  [3, 21, 4],
  [3, 22, 4],
  [3, 23, 1],
  [4, 0, 1],
  [4, 1, 3],
  [4, 2, 0],
  [4, 3, 0],
  [4, 4, 0],
  [4, 5, 1],
  [4, 6, 0],
  [4, 7, 0],
  [4, 8, 0],
  [4, 9, 2],
  [4, 10, 4],
  [4, 11, 4],
  [4, 12, 2],
  [4, 13, 4],
  [4, 14, 4],
  [4, 15, 14],
  [4, 16, 12],
  [4, 17, 1],
  [4, 18, 8],
  [4, 19, 5],
  [4, 20, 3],
  [4, 21, 7],
  [4, 22, 3],
  [4, 23, 0],
  [5, 0, 2],
  [5, 1, 1],
  [5, 2, 0],
  [5, 3, 3],
  [5, 4, 0],
  [5, 5, 0],
  [5, 6, 0],
  [5, 7, 0],
  [5, 8, 2],
  [5, 9, 0],
  [5, 10, 4],
  [5, 11, 1],
  [5, 12, 5],
  [5, 13, 10],
  [5, 14, 5],
  [5, 15, 7],
  [5, 16, 11],
  [5, 17, 6],
  [5, 18, 0],
  [5, 19, 5],
  [5, 20, 3],
  [5, 21, 4],
  [5, 22, 2],
  [5, 23, 0],
  [6, 0, 1],
  [6, 1, 0],
  [6, 2, 0],
  [6, 3, 0],
  [6, 4, 0],
  [6, 5, 0],
  [6, 6, 0],
  [6, 7, 0],
  [6, 8, 0],
  [6, 9, 0],
  [6, 10, 1],
  [6, 11, 0],
  [6, 12, 2],
  [6, 13, 1],
  [6, 14, 3],
  [6, 15, 4],
  [6, 16, 0],
  [6, 17, 0],
  [6, 18, 0],
  [6, 19, 0],
  [6, 20, 1],
  [6, 21, 2],
  [6, 22, 2],
  [6, 23, 6]
];
export const liquidgaugeMockJson = [
  {
    interval_alias: '2020-04-08 00:00:03',
    Name: 'Vi_07_fuel_level_perc',
    Value: 90
  }
];

export const pieMockJson = [
  { tagValue: 1548, tagName: 'HAccPkYY' },
  { tagValue: 535, tagName: 'HAccPkXP' },
  { tagValue: 510, tagName: 'HAccPkYP' },
  { tagValue: 634, tagName: 'HAccPkZP' },
  { tagValue: 735, tagName: 'HAccPkYZ' }
];
export const pieBarMockJson = {
  bar: {
    Envision: {
      frontend: 5000,
      backend: 6000,
      database: 2364,
      Implementation: 1234
    },
    Rubus: {
      frontend: 3237,
      backend: 2164,
      database: 2364,
      Implementation: 1234
    },
    Iportman: {
      frontend: 3237,
      backend: 2164,
      database: 2364,
      Implementation: 1234
    },
    Maximo: {
      frontend: 3237,
      backend: 2164,
      database: 2364,
      Implementation: 1234
    }
  },
  pie: {
    Envision: 17365,
    Rubus: 4079,
    Iportman: 6929,
    Maximo: 14890
  }
};

export const pieNestJson = {
  inner: [
    { tagValue: 1548, tagName: 'Search Engine' },
    { tagValue: 775, tagName: 'Direct' },
    { tagValue: 679, tagName: 'Marketing' }
  ],
  outer: [
    { tagValue: 1048, tagName: 'Baidu' },
    { tagValue: 335, tagName: 'Direct' },
    { tagValue: 310, tagName: 'Email' },
    { tagValue: 251, tagName: 'Google' },
    { tagValue: 234, tagName: 'Union Ads' },
    { tagValue: 147, tagName: 'Bing' },
    { tagValue: 135, tagName: 'Video Ads' },
    { tagValue: 102, tagName: 'Others' }
  ]
};
export const PieNestJSon = {
  inner: [
    { value: 1548, name: 'Search Engine' },
    { value: 775, name: 'Direct' },
    { value: 679, name: 'Marketing' }
  ],
  outer: [
    { value: 1048, name: 'Baidu' },
    { value: 335, name: 'Direct' },
    { value: 310, name: 'Email' },
    { value: 251, name: 'Google' },
    { value: 234, name: 'Union Ads' },
    { value: 147, name: 'Bing' },
    { value: 135, name: 'Video Ads' },
    { value: 102, name: 'Others' }
  ]
};
export const pieLineMockJson = {
  line: [
    {
      interval_alias: '2020-09-21 05:46:00',
      Name: 'DWLC_PV',
      Value: '21.88',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:46:00',
      Name: 'ESCTWLC_PV',
      Value: '-7.14',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:47:00',
      Name: 'DWLC_PV',
      Value: '1.58',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:47:00',
      Name: 'ESCTWLC_PV',
      Value: '-4.77',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:48:00',
      Name: 'DWLC_PV',
      Value: '-1.85',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:48:00',
      Name: 'ESCTWLC_PV',
      Value: '-4.08',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:49:00',
      Name: 'DWLC_PV',
      Value: '-1.78',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:49:00',
      Name: 'ESCTWLC_PV',
      Value: '-3.20',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:50:00',
      Name: 'DWLC_PV',
      Value: '1.92',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:50:00',
      Name: 'ESCTWLC_PV',
      Value: '-1.81',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:51:00',
      Name: 'DWLC_PV',
      Value: '4.53',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:51:00',
      Name: 'ESCTWLC_PV',
      Value: '0.06',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:52:00',
      Name: 'DWLC_PV',
      Value: '4.00',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:52:00',
      Name: 'ESCTWLC_PV',
      Value: '0.83',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:53:00',
      Name: 'DWLC_PV',
      Value: '2.38',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:53:00',
      Name: 'ESCTWLC_PV',
      Value: '2.33',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:54:00',
      Name: 'DWLC_PV',
      Value: '-2.79',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:54:00',
      Name: 'ESCTWLC_PV',
      Value: '3.87',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:55:00',
      Name: 'DWLC_PV',
      Value: '-6.66',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:55:00',
      Name: 'ESCTWLC_PV',
      Value: '4.71',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:56:00',
      Name: 'DWLC_PV',
      Value: '-4.57',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:56:00',
      Name: 'ESCTWLC_PV',
      Value: '20.63',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:57:00',
      Name: 'DWLC_PV',
      Value: '-2.37',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:57:00',
      Name: 'ESCTWLC_PV',
      Value: '25.82',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:58:00',
      Name: 'DWLC_PV',
      Value: '2.88',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:58:00',
      Name: 'ESCTWLC_PV',
      Value: '23.21',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 05:59:00',
      Name: 'DWLC_PV',
      Value: '7.54',
      tag_description: 'Deaerator water level control PV'
    },
    {
      interval_alias: '2020-09-21 05:59:00',
      Name: 'ESCTWLC_PV',
      Value: '20.35',
      tag_description: 'Exhaust steam condenser tank water level  Control PV'
    },
    {
      interval_alias: '2020-09-21 06:00:00',
      Name: 'DWLC_PV',
      Value: '11.68',
      tag_description: 'Deaerator water level control PV'
    }
  ],
  pie: {
    'Exhaust steam condenser tank water level  Control PV': 17365,
    'Deaerator water level control PV': 4079
  }
};

export const pieSingleMockJson = {
  line: {
    Site_1: [
      ['2000-06-05', 116],
      ['2000-06-06', 129],
      ['2000-06-07', 135],
      ['2000-06-08', 86],
      ['2000-06-09', 73],
      ['2000-06-10', 85],
      ['2000-06-11', 73],
      ['2014-07-25', 134],
      ['2014-07-26', 188],
      ['2014-07-27', 194],
      ['2014-07-28', 159],
      ['2014-07-29', 159],
      ['2014-07-30', 169],
      ['2014-07-31', 244],
      ['2014-08-01', 199],
      ['2014-08-02', 163],
      ['2014-08-03', 149],
      ['2014-08-05', 80]
    ],
    Site_2: [
      ['2000-06-05', 116],
      ['2000-06-06', 129],
      ['2000-06-07', 135],
      ['2000-06-08', 86],
      ['2000-06-09', 73],
      ['2000-06-10', 85],
      ['2000-06-11', 73],
      ['2014-07-25', 134],
      ['2014-07-26', 188],
      ['2014-07-27', 194],
      ['2014-07-28', 159],
      ['2014-07-29', 159],
      ['2014-07-30', 169],
      ['2014-07-31', 244],
      ['2014-08-01', 199],
      ['2014-08-02', 163],
      ['2014-08-03', 149],
      ['2014-08-05', 80],
      ['2014-08-06', 67],
      ['2014-08-07', 162],
      ['2014-08-08', 140]
    ],
    Site_3: [
      ['2000-06-05', 116],
      ['2000-06-06', 129],
      ['2000-06-07', 135],
      ['2000-06-08', 86],
      ['2000-06-09', 73],
      ['2000-06-10', 85],
      ['2000-06-11', 73],
      ['2014-07-25', 134],
      ['2014-07-26', 188],
      ['2014-07-27', 194],
      ['2014-07-28', 159],
      ['2014-07-29', 159],
      ['2014-07-30', 169],
      ['2014-07-31', 244],
      ['2014-08-01', 199],
      ['2014-08-02', 163],
      ['2014-08-03', 149],
      ['2014-08-05', 80],
      ['2014-08-06', 67],
      ['2014-08-07', 162],
      ['2014-08-08', 140]
    ],
    Site_4: [
      ['2000-06-05', 116],
      ['2000-06-06', 129],
      ['2000-06-07', 135],
      ['2000-06-08', 86],
      ['2000-06-09', 73],
      ['2000-06-10', 85],
      ['2000-06-11', 73],
      ['2014-07-25', 134],
      ['2014-07-26', 188],
      ['2014-07-27', 194],
      ['2014-07-28', 159],
      ['2014-07-29', 159],
      ['2014-07-30', 169],
      ['2014-07-31', 244],
      ['2014-08-01', 199],
      ['2014-08-02', 163],
      ['2014-08-03', 149],
      ['2014-08-05', 80],
      ['2014-08-06', 67],
      ['2014-08-07', 162]
    ]
  },
  pie: { Site_1: 17365, Site_2: 4079, Site_3: 6929, Site_4: 14890 }
};

export const regressionMockJson = [
  [1, 4862.4],
  [2, 5294.7],
  [3, 5934.5],
  [4, 7171.0],
  [5, 8964.4],
  [6, 10202.2],
  [7, 11962.5],
  [8, 14928.3],
  [9, 16909.2],
  [10, 18547.9],
  [11, 21617.8],
  [12, 26638.1],
  [13, 34634.4],
  [14, 46759.4],
  [15, 58478.1],
  [16, 67884.6],
  [17, 74462.6],
  [18, 1200.7]
];

export const sliderMockJson = [];
export const stackBarMockJson = [];
export const sliderstatus = [
  {
    DateTime: '2021-06-25 11:12:15',
    Name: 'Load',
    Value: 20,
    Description: 'Load',
    Color: 'green',
    GT: 0,
    LTE: 8
  },
  {
    interval_alias: '2021-06-25 11:12:15',
    Name: 'BeltSpeed',
    Value: 20,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 0,
    LTE: 8
  },
  {
    interval_alias: '2021-06-25 11:13:15',
    Name: 'Load',
    Value: 29,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:13:15',
    Name: 'BeltSpeed',
    Value: 19,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 0,
    LTE: 8
  },
  {
    interval_alias: '2021-06-25 11:13:15',
    Name: 'BeltSpeed',
    Value: 19,
    tag_description: 'BeltSpeed',
    color: 'red',
    GT: 8,
    LTE: 15
  },
  {
    interval_alias: '2021-06-25 11:14:15',
    Name: 'Load',
    Value: 29,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:14:15',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 15,
    LTE: 20
  },
  {
    interval_alias: '2021-06-25 11:15:15',
    Name: 'Load',
    Value: 25,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:15:15',
    Name: 'BeltSpeed',
    Value: 25,
    tag_description: 'BeltSpeed',
    color: 'red',
    GT: 20,
    LTE: 25
  },
  {
    interval_alias: '2021-06-25 11:16:15',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:16:15',
    Name: 'BeltSpeed',
    Value: 27,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:17:15',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:17:15',
    Name: 'BeltSpeed',
    Value: 9,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:18:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:18:14',
    Name: 'BeltSpeed',
    Value: 19,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:19:14',
    Name: 'Load',
    Value: 29,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:19:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:20:14',
    Name: 'Load',
    Value: 29,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:20:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:21:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:21:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:22:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:22:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:23:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:23:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:24:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:24:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:25:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:25:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:26:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:26:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:27:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:27:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:28:15',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:28:15',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:29:15',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:29:15',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:30:15',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:30:15',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:31:15',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:31:15',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:32:15',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:32:15',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:33:15',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:33:15',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:34:15',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:34:15',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:35:15',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:35:15',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:36:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:36:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:37:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:37:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:38:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:38:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:39:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:39:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:40:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:40:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  },
  {
    interval_alias: '2021-06-25 11:41:14',
    Name: 'Load',
    Value: 27,
    tag_description: 'Load'
  },
  {
    interval_alias: '2021-06-25 11:41:14',
    Name: 'BeltSpeed',
    Value: 29,
    tag_description: 'BeltSpeed',
    color: 'green',
    GT: 25,
    LTE: null
  }
];
export const stackedBarMock = {
  bar: [
    {
      intervalAlias: [
        '11-11-2020',
        '12-11-2020',
        '13-11-2020',
        '14-11-2020',
        '15-11-2020',
        '16-11-2020',
        '17-11-2020'
      ]
    },
    {
      tagName: 'meter1',
      tagValue: [100, 200, 300, 400, 500, 600, 700]
    },
    {
      tagName: 'meter2',
      tagValue: [120, 130, 140, 150, 160, 170, 180]
    },
    {
      tagName: 'meter3',
      tagValue: [220, 230, 240, 250, 260, 270, 280]
    },
    {
      tagName: 'meter4',
      tagValue: [320, 330, 340, 350, 350, 360, 370]
    },
    {
      tagName: 'meter5',
      tagValue: [420, 430, 440, 450, 460, 470, 480]
    }
  ],
  table: [
    { name: 'Meter1', consumption: 2800, location: 'Boiler1' },
    { name: 'Meter2', consumption: 1050, location: 'Conveyor' },
    { name: 'Meter3', consumption: 1750, location: 'Turbine' },
    { name: 'Meter4', consumption: 2070, location: 'Boiler2' },
    { name: 'Meter5', consumption: 3150, location: 'Compressor' }
  ]
};
export const progressBarMock = {
  interval_alias: '2020-05-13T14:22:16.303Z',
  Name: 'TRR_PIC301_PV',
  Value: 45,
  tag_description: 'Main steam pressure control'
};
export const statusCounterMock = [
  {
    interval_alias: '2020-05-12T21:49:05.161Z',
    Name: 'TRR_TIC301_PV',
    Value: 395.4,
    status: 'Low',
    statusValue: '54.0',
    tag_description: 'Main stream temperature control'
  }
];

export const tableMock = [
  {
    PredictionTime: '1 minute',
    'Main stream temperature control': 421.56,
    'Main steam pressure control': 5.72,
    'Main steam volume': 12.26,
    Moisture: 72
  },
  {
    PredictionTime: '2 minutes',
    'Main stream temperature control': 421.55,
    'Main steam pressure control': 5.72,
    'Main steam volume': 12.11,
    Moisture: 68
  },
  {
    PredictionTime: '3 minutes',
    'Main stream temperature control': 421.48,
    'Main steam pressure control': 5.67,
    'Main steam volume': 12.48,
    Moisture: 74
  },
  {
    PredictionTime: '4 minutes',
    'Main stream temperature control': 420.15,
    'Main steam pressure control': 5.57,
    'Main steam volume': 12.81,
    Moisture: 76
  },
  {
    PredictionTime: '5 minutes',
    'Main stream temperature control': 421.22,
    'Main steam pressure control': 5.68,
    'Main steam volume': 12.92,
    Moisture: 73
  }
];
export const treeGraphMock = [];
export const windBarbMock = [
  {
    time: '2017-06-27T11:00:00.000Z',
    windSpeed: 9,
    R: 'NNW',
    waveHeight: 2.64
  },
  {
    time: '2017-06-27T12:30:00.000Z',
    windSpeed: 10,
    R: 'NNW',
    waveHeight: 2.57
  },
  {
    time: '2017-06-27T14:00:00.000Z',
    windSpeed: 12,
    R: 'NNW',
    waveHeight: 2.49
  },
  {
    time: '2017-06-27T15:30:00.000Z',
    windSpeed: 12,
    R: 'NNW',
    waveHeight: 2.44
  },
  {
    time: '2017-06-27T17:00:00.000Z',
    windSpeed: 11,
    R: 'NNW',
    waveHeight: 2.38
  },
  {
    time: '2017-06-27T18:30:00.000Z',
    windSpeed: 10,
    R: 'NNW',
    waveHeight: 2.34
  },
  {
    time: '2017-06-27T20:00:00.000Z',
    windSpeed: 10,
    R: 'N',
    waveHeight: 2.3
  },
  {
    time: '2017-06-27T21:30:00.000Z',
    windSpeed: 11,
    R: 'NNW',
    waveHeight: 2.26
  },
  {
    time: '2017-06-27T23:00:00.000Z',
    windSpeed: 12,
    R: 'NNW',
    waveHeight: 2.22
  },
  {
    time: '2017-06-28T00:30:00.000Z',
    windSpeed: 12,
    R: 'N',
    waveHeight: 2.18
  },
  {
    time: '2017-06-28T02:00:00.000Z',
    windSpeed: 12,
    R: 'N',
    waveHeight: 2.13
  },
  {
    time: '2017-06-28T03:30:00.000Z',
    windSpeed: 12,
    R: 'N',
    waveHeight: 2.09
  },
  {
    time: '2017-06-28T05:00:00.000Z',
    windSpeed: 12,
    R: 'NNE',
    waveHeight: 2.04
  },
  {
    time: '2017-06-28T06:30:00.000Z',
    windSpeed: 10,
    R: 'N',
    waveHeight: 2.01
  },
  {
    time: '2017-06-28T08:00:00.000Z',
    windSpeed: 9,
    R: 'N',
    waveHeight: 1.99
  },
  {
    time: '2017-06-28T09:30:00.000Z',
    windSpeed: 8,
    R: 'NNW',
    waveHeight: 2
  },
  {
    time: '2017-06-28T11:00:00.000Z',
    windSpeed: 8,
    R: 'NW',
    waveHeight: 2.01
  },
  {
    time: '2017-06-28T12:30:00.000Z',
    windSpeed: 8,
    R: 'NW',
    waveHeight: 2.06
  },
  {
    time: '2017-06-28T14:00:00.000Z',
    windSpeed: 9,
    R: 'WNW',
    waveHeight: 2.12
  },
  {
    time: '2017-06-28T15:30:00.000Z',
    windSpeed: 10,
    R: 'WNW',
    waveHeight: 2.19
  },
  {
    time: '2017-06-28T17:00:00.000Z',
    windSpeed: 11,
    R: 'WNW',
    waveHeight: 2.27
  },
  {
    time: '2017-06-28T18:30:00.000Z',
    windSpeed: 12,
    R: 'WNW',
    waveHeight: 2.33
  },
  {
    time: '2017-06-28T20:00:00.000Z',
    windSpeed: 13,
    R: 'NW',
    waveHeight: 2.39
  },
  {
    time: '2017-06-28T21:30:00.000Z',
    windSpeed: 13,
    R: 'NW',
    waveHeight: 2.43
  },
  {
    time: '2017-06-28T23:00:00.000Z',
    windSpeed: 14,
    R: 'NW',
    waveHeight: 2.46
  },
  {
    time: '2017-06-29T00:30:00.000Z',
    windSpeed: 16,
    R: 'NW',
    waveHeight: 2.48
  },
  {
    time: '2017-06-29T02:00:00.000Z',
    windSpeed: 18,
    R: 'NNW',
    waveHeight: 2.49
  },
  {
    time: '2017-06-29T03:30:00.000Z',
    windSpeed: 20,
    R: 'WNW',
    waveHeight: 2.53
  },
  {
    time: '2017-06-29T05:00:00.000Z',
    windSpeed: 22,
    R: 'W',
    waveHeight: 2.58
  },
  {
    time: '2017-06-29T06:30:00.000Z',
    windSpeed: 26,
    R: 'WSW',
    waveHeight: 2.89
  },
  {
    time: '2017-06-29T08:00:00.000Z',
    windSpeed: 30,
    R: 'WSW',
    waveHeight: 3.21
  },
  {
    time: '2017-06-29T09:30:00.000Z',
    windSpeed: 30,
    R: 'SW',
    waveHeight: 3.58
  },
  {
    time: '2017-06-29T11:00:00.000Z',
    windSpeed: 29,
    R: 'SW',
    waveHeight: 3.94
  },
  {
    time: '2017-06-29T12:30:00.000Z',
    windSpeed: 29,
    R: 'SW',
    waveHeight: 4.08
  },
  {
    time: '2017-06-29T14:00:00.000Z',
    windSpeed: 29,
    R: 'SW',
    waveHeight: 4.22
  },
  {
    time: '2017-06-29T15:30:00.000Z',
    windSpeed: 28,
    R: 'SW',
    waveHeight: 4.25
  },
  {
    time: '2017-06-29T17:00:00.000Z',
    windSpeed: 28,
    R: 'SW',
    waveHeight: 4.28
  },
  {
    time: '2017-06-29T18:30:00.000Z',
    windSpeed: 29,
    R: 'SSW',
    waveHeight: 4.37
  },
  {
    time: '2017-06-29T20:00:00.000Z',
    windSpeed: 30,
    R: 'SSW',
    waveHeight: 4.45
  },
  {
    time: '2017-06-29T21:30:00.000Z',
    windSpeed: 29,
    R: 'SSW',
    waveHeight: 4.45
  },
  {
    time: '2017-06-29T23:00:00.000Z',
    windSpeed: 27,
    R: 'SSW',
    waveHeight: 4.45
  },
  {
    time: '2017-06-30T00:30:00.000Z',
    windSpeed: 26,
    R: 'SSW',
    waveHeight: 4.32
  },
  {
    time: '2017-06-30T02:00:00.000Z',
    windSpeed: 25,
    R: 'SSW',
    waveHeight: 4.2
  },
  {
    time: '2017-06-30T03:30:00.000Z',
    windSpeed: 22,
    R: 'SSW',
    waveHeight: 4.01
  },
  {
    time: '2017-06-30T05:00:00.000Z',
    windSpeed: 20,
    R: 'SSW',
    waveHeight: 3.82
  },
  {
    time: '2017-06-30T06:30:00.000Z',
    windSpeed: 19,
    R: 'SSW',
    waveHeight: 3.66
  },
  {
    time: '2017-06-30T08:00:00.000Z',
    windSpeed: 19,
    R: 'SSW',
    waveHeight: 3.51
  },
  {
    time: '2017-06-30T09:30:00.000Z',
    windSpeed: 17,
    R: 'SSW',
    waveHeight: 3.37
  },
  {
    time: '2017-06-30T11:00:00.000Z',
    windSpeed: 14,
    R: 'SSW',
    waveHeight: 3.22
  },
  {
    time: '2017-06-30T12:30:00.000Z',
    windSpeed: 12,
    R: 'SSW',
    waveHeight: 3.09
  },
  {
    time: '2017-06-30T14:00:00.000Z',
    windSpeed: 10,
    R: 'SW',
    waveHeight: 2.96
  },
  {
    time: '2017-06-30T15:30:00.000Z',
    windSpeed: 9,
    R: 'WSW',
    waveHeight: 2.83
  },
  {
    time: '2017-06-30T17:00:00.000Z',
    windSpeed: 9,
    R: 'W',
    waveHeight: 2.7
  },
  {
    time: '2017-06-30T18:30:00.000Z',
    windSpeed: 10,
    R: 'W',
    waveHeight: 2.58
  },
  {
    time: '2017-06-30T20:00:00.000Z',
    windSpeed: 10,
    R: 'WNW',
    waveHeight: 2.45
  },
  {
    time: '2017-06-30T21:30:00.000Z',
    windSpeed: 10,
    R: 'WNW',
    waveHeight: 2.33
  },
  {
    time: '2017-06-30T23:00:00.000Z',
    windSpeed: 10,
    R: 'WNW',
    waveHeight: 2.21
  },
  {
    time: '2017-07-01T00:30:00.000Z',
    windSpeed: 10,
    R: 'NW',
    waveHeight: 2.13
  },
  {
    time: '2017-07-01T02:00:00.000Z',
    windSpeed: 10,
    R: 'NW',
    waveHeight: 2.05
  },
  {
    time: '2017-07-01T03:30:00.000Z',
    windSpeed: 10,
    R: 'NNW',
    waveHeight: 2.02
  },
  {
    time: '2017-07-01T05:00:00.000Z',
    windSpeed: 10,
    R: 'N',
    waveHeight: 2
  },
  {
    time: '2017-07-01T06:30:00.000Z',
    windSpeed: 10,
    R: 'N',
    waveHeight: 2
  },
  {
    time: '2017-07-01T08:00:00.000Z',
    windSpeed: 10,
    R: 'N',
    waveHeight: 1.99
  },
  {
    time: '2017-07-01T09:30:00.000Z',
    windSpeed: 10,
    R: 'N',
    waveHeight: 1.98
  },
  {
    time: '2017-07-01T11:00:00.000Z',
    windSpeed: 10,
    R: 'N',
    waveHeight: 1.96
  },
  {
    time: '2017-07-01T12:30:00.000Z',
    windSpeed: 10,
    R: 'N',
    waveHeight: 1.94
  },
  {
    time: '2017-07-01T14:00:00.000Z',
    windSpeed: 11,
    R: 'N',
    waveHeight: 1.93
  },
  {
    time: '2017-07-01T15:30:00.000Z',
    windSpeed: 11,
    R: 'N',
    waveHeight: 1.93
  },
  {
    time: '2017-07-01T17:00:00.000Z',
    windSpeed: 11,
    R: 'NNW',
    waveHeight: 1.93
  },
  {
    time: '2017-07-01T18:30:00.000Z',
    windSpeed: 10,
    R: 'NNW',
    waveHeight: 1.94
  },
  {
    time: '2017-07-01T20:00:00.000Z',
    windSpeed: 10,
    R: 'NNW',
    waveHeight: 1.96
  },
  {
    time: '2017-07-01T21:30:00.000Z',
    windSpeed: 10,
    R: 'NNW',
    waveHeight: 1.97
  },
  {
    time: '2017-07-01T23:00:00.000Z',
    windSpeed: 10,
    R: 'NNW',
    waveHeight: 1.97
  },
  {
    time: '2017-07-02T00:30:00.000Z',
    windSpeed: 10,
    R: 'N',
    waveHeight: 1.96
  },
  {
    time: '2017-07-02T02:00:00.000Z',
    windSpeed: 11,
    R: 'N',
    waveHeight: 1.94
  },
  {
    time: '2017-07-02T03:30:00.000Z',
    windSpeed: 11,
    R: 'N',
    waveHeight: 1.91
  },
  {
    time: '2017-07-02T05:00:00.000Z',
    windSpeed: 10,
    R: 'N',
    waveHeight: 1.88
  },
  {
    time: '2017-07-02T06:30:00.000Z',
    windSpeed: 10,
    R: 'N',
    waveHeight: 1.84
  },
  {
    time: '2017-07-02T08:00:00.000Z',
    windSpeed: 10,
    R: 'N',
    waveHeight: 1.8
  },
  {
    time: '2017-07-02T09:30:00.000Z',
    windSpeed: 11,
    R: 'N',
    waveHeight: 1.78
  },
  {
    time: '2017-07-02T11:00:00.000Z',
    windSpeed: 11,
    R: 'N',
    waveHeight: 1.76
  },
  {
    time: '2017-07-02T12:30:00.000Z',
    windSpeed: 12,
    R: 'N',
    waveHeight: 1.76
  },
  {
    time: '2017-07-02T14:00:00.000Z',
    windSpeed: 13,
    R: 'N',
    waveHeight: 1.77
  },
  {
    time: '2017-07-02T15:30:00.000Z',
    windSpeed: 14,
    R: 'N',
    waveHeight: 1.81
  },
  {
    time: '2017-07-02T17:00:00.000Z',
    windSpeed: 15,
    R: 'N',
    waveHeight: 1.85
  },
  {
    time: '2017-07-02T18:30:00.000Z',
    windSpeed: 14,
    R: 'N',
    waveHeight: 1.86
  },
  {
    time: '2017-07-02T20:00:00.000Z',
    windSpeed: 13,
    R: 'N',
    waveHeight: 1.87
  },
  {
    time: '2017-07-02T21:30:00.000Z',
    windSpeed: 13,
    R: 'N',
    waveHeight: 1.88
  },
  {
    time: '2017-07-02T23:00:00.000Z',
    windSpeed: 13,
    R: 'N',
    waveHeight: 1.9
  },
  {
    time: '2017-07-03T00:30:00.000Z',
    windSpeed: 13,
    R: 'N',
    waveHeight: 1.91
  },
  {
    time: '2017-07-03T02:00:00.000Z',
    windSpeed: 13,
    R: 'N',
    waveHeight: 1.93
  },
  {
    time: '2017-07-03T03:30:00.000Z',
    windSpeed: 13,
    R: 'N',
    waveHeight: 1.96
  },
  {
    time: '2017-07-03T05:00:00.000Z',
    windSpeed: 13,
    R: 'NNE',
    waveHeight: 1.99
  },
  {
    time: '2017-07-03T06:30:00.000Z',
    windSpeed: 12,
    R: 'NNE',
    waveHeight: 2.03
  },
  {
    time: '2017-07-03T08:00:00.000Z',
    windSpeed: 11,
    R: 'NNE',
    waveHeight: 2.08
  },
  {
    time: '2017-07-03T09:30:00.000Z',
    windSpeed: 11,
    R: 'N',
    waveHeight: 2.12
  },
  {
    time: '2017-07-03T11:00:00.000Z',
    windSpeed: 11,
    R: 'NNW',
    waveHeight: 2.16
  },
  {
    time: '2017-07-03T12:30:00.000Z',
    windSpeed: 15,
    R: 'N',
    waveHeight: 2.22
  },
  {
    time: '2017-07-03T14:00:00.000Z',
    windSpeed: 20,
    R: 'N',
    waveHeight: 2.27
  },
  {
    time: '2017-07-03T15:30:00.000Z',
    windSpeed: 20,
    R: 'N',
    waveHeight: 2.33
  },
  {
    time: '2017-07-03T17:00:00.000Z',
    windSpeed: 19,
    R: 'N',
    waveHeight: 2.39
  },
  {
    time: '2017-07-03T18:30:00.000Z',
    windSpeed: 17,
    R: 'N',
    waveHeight: 2.44
  },
  {
    time: '2017-07-03T20:00:00.000Z',
    windSpeed: 15,
    R: 'N',
    waveHeight: 2.49
  },
  {
    time: '2017-07-03T21:30:00.000Z',
    windSpeed: 16,
    R: 'NNW',
    waveHeight: 2.49
  },
  {
    time: '2017-07-03T23:00:00.000Z',
    windSpeed: 17,
    R: 'WNW',
    waveHeight: 2.49
  },
  {
    time: '2017-07-04T00:30:00.000Z',
    windSpeed: 18,
    R: 'W',
    waveHeight: 2.47
  },
  {
    time: '2017-07-04T02:00:00.000Z',
    windSpeed: 20,
    R: 'SW',
    waveHeight: 2.44
  },
  {
    time: '2017-07-04T03:30:00.000Z',
    windSpeed: 21,
    R: 'SW',
    waveHeight: 2.5
  },
  {
    time: '2017-07-04T05:00:00.000Z',
    windSpeed: 21,
    R: 'WSW',
    waveHeight: 2.56
  },
  {
    time: '2017-07-04T06:30:00.000Z',
    windSpeed: 22,
    R: 'WSW',
    waveHeight: 2.69
  },
  {
    time: '2017-07-04T08:00:00.000Z',
    windSpeed: 22,
    R: 'WSW',
    waveHeight: 2.83
  },
  {
    time: '2017-07-04T09:30:00.000Z',
    windSpeed: 23,
    R: 'WSW',
    waveHeight: 2.94
  },
  {
    time: '2017-07-04T11:00:00.000Z',
    windSpeed: 23,
    R: 'WSW',
    waveHeight: 3.06
  },
  {
    time: '2017-07-04T12:30:00.000Z',
    windSpeed: 24,
    R: 'WSW',
    waveHeight: 3.06
  },
  {
    time: '2017-07-04T14:00:00.000Z',
    windSpeed: 24,
    R: 'SW',
    waveHeight: 3.06
  },
  {
    time: '2017-07-04T15:30:00.000Z',
    windSpeed: 25,
    R: 'SW',
    waveHeight: 3.04
  },
  {
    time: '2017-07-04T17:00:00.000Z',
    windSpeed: 25,
    R: 'SW',
    waveHeight: 3.03
  },
  {
    time: '2017-07-04T18:30:00.000Z',
    windSpeed: 26,
    R: 'SW',
    waveHeight: 3
  },
  {
    time: '2017-07-04T20:00:00.000Z',
    windSpeed: 26,
    R: 'SW',
    waveHeight: 2.97
  }
];

export const rangleDualTableJson = {
  actual: [
    {
      Period: 'Daily',
      'Planned Amount(kW)': 37471,
      'Actual Amount(kW)': '29294.89',
      'Achievement Rate(%)': '78.18'
    },
    {
      Period: 'Monthly',
      'Planned Amount(kW)': 1161600,
      'Actual Amount(kW)': '555718.73',
      'Achievement Rate(%)': '47.84'
    },
    {
      Period: 'Yearly',
      'Planned Amount(kW)': 13939200,
      'Actual Amount(kW)': '5433099.44',
      'Achievement Rate(%)': '38.98'
    }
  ],
  planned: [
    {
      Period: 'Daily',
      'Planned Amount(kW)': 37471,
      'Actual Amount(kW)': '29294.89',
      'Achievement Rate(%)': '78.18'
    },
    {
      Period: 'Monthly',
      'Planned Amount(kW)': 1161600,
      'Actual Amount(kW)': '555718.73',
      'Achievement Rate(%)': '47.84'
    },
    {
      Period: 'Yearly',
      'Planned Amount(kW)': 13939200,
      'Actual Amount(kW)': '5433099.44',
      'Achievement Rate(%)': '38.98'
    }
  ]
};

export const guageRingMock = [
  {
    value: 40,
    name: 'Temperature'
  },
  {
    value: 80,
    name: 'Pressure'
  }
];

export const progressMock = [
  {
    interval_alias: '2020-05-13T14:22:16.303Z',
    Name: 'TRR_PIC301_PV',
    Value: 0,
    tag_description: 'Main steam pressure control'
  }
];
export const notificationtableMock = [
  {
    eventStatus: {
      interval_alias: '2020-05-12T21:49:05.161Z',
      Name: 'TRR_TIC301_PV',
      raisedEvents: '5',
      // status: "Low",
      closedEvents: '3',
      tag_description: 'Main stream temperature control'
    },
    tabledata: [
      {
        'S.No': '1',
        Location: 'Substation-02',
        'Meter Id': '1',
        'Meter Type': 'Energy Meter',
        'Meter Name': 'Incomer-1',
        Status: 'Available',
        Timestamp: '2021-05-29 16:19:06'
      },
      {
        'S.No': '2',
        Location: 'Substation-02',
        'Meter Id': '2',
        'Meter Type': 'Energy Meter',
        'Meter Name': 'Incomer-2',
        Status: 'Available',
        Timestamp: '2021-05-29 16:19:06'
      },
      {
        'S.No': '3',
        Location: 'Substation-03',
        'Meter Id': '3',
        'Meter Type': 'Energy Meter',
        'Meter Name': 'Incomer-3',
        Status: 'NotAvailable',
        Timestamp: '2021-05-29 16:19:06'
      }
    ]
  }
];

export const imageMock = [
  {
    id: 1,
    category: 'fruits',
    imageUrl: 'http://placeimg.com/1200/800/nature'
  },
  {
    id: 2,
    category: 'fruits',
    imageUrl: 'http://placeimg.com/800/1200/nature'
  },
  {
    id: 3,
    category: 'fruits',
    imageUrl: 'http://placeimg.com/1920/1080/nature'
  },
  {
    id: 4,
    category: 'vegetables',
    imageUrl: 'http://placeimg.com/1500/500/nature'
  }
];

export const selectImageMock = {
  options: [
    {
      value: 'AP23ef1234',
      label: 'AP23ef1234',
      children: [
        {
          value: '123456',
          label: '123456'
        }
      ]
    },
    {
      value: 'AP23ef12345',
      label: 'AP23ef12345',
      children: [
        {
          value: '12345',
          label: '12345'
        }
      ]
    }
  ],
  data: [
    {
      imagesList: ['http://placeimg.com/1920/1080/nature', 'http://placeimg.com/1500/500/nature'],
      parentKey: 'AP23ef1234',
      childKey: '123456',
      truckDetails: [
        {
          title: 'truckId',
          value: '1234'
        },
        {
          title: 'truckNumber',
          value: 'AP23ef1234'
        }
      ]
    },
    {
      imagesList: ['url1', 'url2'],
      parentKey: 'AP23ef1234',
      childKey: '124567',
      truckDetails: [
        {
          title: 'truckId',
          value: '567'
        },
        {
          title: 'truckNumber',
          value: 'AP23ef567'
        }
      ]
    },
    {
      imagesList: ['url1', 'url2'],
      parentKey: 'AP23ef1235',
      childKey: '12345',
      truckDetails: [
        {
          title: 'truckId',
          value: '456'
        },
        {
          title: 'truckNumber',
          value: 'AP23ef456'
        }
      ]
    },
    {
      imagesList: ['http://placeimg.com/1920/1080/nature', 'http://placeimg.com/1500/500/nature'],
      parentKey: 'AP23ef1235',
      childKey: '124567',
      truckDetails: [
        {
          title: 'truckId',
          value: '789'
        },
        {
          title: 'truckNumber',
          value: 'AP23ef789'
        }
      ]
    }
  ]
};
export const geoLocations = [
  {
    name: 'Andha Pradesh',
    latitude: 15.9129,
    longitude: 79.74,
    parentlatitude: 20.5937,
    parentLongitude: 78.9629,
    parentZoom: 5,
    datavalue: '0',
    iconUrl: '/api/masterImages/Farm_red_V1.png'
  },
  {
    name: 'Telangana',
    latitude: 17.1232,
    longitude: 79.2088,
    parentlatitude: 20.5937,
    parentLongitude: 78.9629,
    parentZoom: 5,
    datavalue: '1',
    iconUrl: '/api/masterImages/Farm_blue_V1.png'
  },
  {
    name: 'Delhi',
    latitude: 28.7041,
    longitude: 77.1025,
    parentlatitude: 20.5937,
    parentLongitude: 78.9629,
    parentZoom: 5,
    datavalue: '2',
    iconUrl: '/api/masterImages/Farm_green_V1.png'
  },
  {
    name: 'Mumbai',
    latitude: 19.076,
    longitude: 72.8777,
    parentlatitude: 20.5937,
    parentLongitude: 78.9629,
    parentZoom: 5,
    datavalue: '2',
    iconUrl: '/api/masterImages/Farm_green_V1.png'
  },
  {
    name: 'Kerla',
    latitude: 10.8505,
    longitude: 76.2711,
    parentlatitude: 20.5937,
    parentLongitude: 78.9629,
    parentZoom: 5,
    datavalue: '3',
    iconUrl: '/api/masterImages/Farm_yellow_V1.png'
  }
];

export const GeoMapMock = [
  [488.2358421078053, 459.70913833075736, 100],
  [770.3415644319939, 757.9672194986475, 30],
  [1180.0329284196291, 743.6141808346214, 80],
  [894.03790632245, 1188.1985153835008, 61],
  [1372.98925630313, 477.3839988649537, 70],
  [1378.62251255796, 935.6708486282843, 81]
];

export const SunBurstMock = [
  {
    name: 'Grandpa',
    children: [
      {
        name: 'Uncle Leo',
        value: 15,
        children: [
          {
            name: 'Cousin Jack',
            value: 2
          },
          {
            name: 'Cousin Mary',
            value: 5,
            children: [
              {
                name: 'Jackson',
                value: 2
              }
            ]
          },
          {
            name: 'Cousin Ben',
            value: 4
          }
        ]
      },
      {
        name: 'Father',
        value: 10,
        children: [
          {
            name: 'Me',
            value: 5
          },
          {
            name: 'Brother Peter',
            value: 1
          }
        ]
      }
    ]
  },
  {
    name: 'Nancy',
    children: [
      {
        name: 'Uncle Nike',
        children: [
          {
            name: 'Cousin Betty',
            value: 1
          },
          {
            name: 'Cousin Jenny',
            value: 2
          }
        ]
      }
    ]
  }
];

export const WarningDashboard = [
  {
    DateTime: '2022-05-25 05:25:55',
    Name: 'Value',
    Value: -1.88,
    Description: 'Deaerator level control@@PV (mm)'
  },
  {
    DateTime: '2022-05-25 05:25:56',
    Name: 'Value',
    Value: -1.76,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:25:57',
    Name: 'Value',
    Value: -1.74,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:25:58',
    Name: 'Value',
    Value: -1.74,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:25:59',
    Name: 'Value',
    Value: -1.62,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:00',
    Name: 'Value',
    Value: -1.49,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:01',
    Name: 'Value',
    Value: -1.49,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:02',
    Name: 'Value',
    Value: -1.36,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:03',
    Name: 'Value',
    Value: -1.23,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:04',
    Name: 'Value',
    Value: -0.99,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:05',
    Name: 'Value',
    Value: -0.98,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:06',
    Name: 'Value',
    Value: -0.73,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:07',
    Name: 'Value',
    Value: -0.48,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:08',
    Name: 'Value',
    Value: -0.24,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:09',
    Name: 'Value',
    Value: -0.1,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:11',
    Name: 'Value',
    Value: 0.01,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:11',
    Name: 'Value',
    Value: 0.26,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:12',
    Name: 'Value',
    Value: 0.5,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:13',
    Name: 'Value',
    Value: 0.87,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:14',
    Name: 'Value',
    Value: 1.12,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:15',
    Name: 'Value',
    Value: 1.49,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:16',
    Name: 'Value',
    Value: 1.85,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:17',
    Name: 'Value',
    Value: 2.23,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:18',
    Name: 'Value',
    Value: 2.59,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:19',
    Name: 'Value',
    Value: 2.96,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:20',
    Name: 'Value',
    Value: 3.33,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:21',
    Name: 'Value',
    Value: 3.57,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:22',
    Name: 'Value',
    Value: 4.07,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:23',
    Name: 'Value',
    Value: 4.32,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:24',
    Name: 'Value',
    Value: 4.69,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:25',
    Name: 'Value',
    Value: 4.95,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:26',
    Name: 'Value',
    Value: 5.2,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:27',
    Name: 'Value',
    Value: 5.45,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:28',
    Name: 'Value',
    Value: 5.71,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:29',
    Name: 'Value',
    Value: 5.95,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:30',
    Name: 'Value',
    Value: 6.09,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:31',
    Name: 'Value',
    Value: 6.33,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:32',
    Name: 'Value',
    Value: 6.59,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:33',
    Name: 'Value',
    Value: 6.83,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:34',
    Name: 'Value',
    Value: 6.96,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:35',
    Name: 'Value',
    Value: 7.08,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:36',
    Name: 'Value',
    Value: 7.21,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:37',
    Name: 'Value',
    Value: 7.35,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:38',
    Name: 'Value',
    Value: 7.47,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:39',
    Name: 'Value',
    Value: 7.59,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:41',
    Name: 'Value',
    Value: 7.59,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:41',
    Name: 'Value',
    Value: 7.6,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:42',
    Name: 'Value',
    Value: 7.72,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:43',
    Name: 'Value',
    Value: 7.6,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:44',
    Name: 'Value',
    Value: 7.6,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:45',
    Name: 'Value',
    Value: 7.61,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:46',
    Name: 'Value',
    Value: 7.48,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:47',
    Name: 'Value',
    Value: 7.49,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:48',
    Name: 'Value',
    Value: 7.36,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:49',
    Name: 'Value',
    Value: 7.12,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:50',
    Name: 'Value',
    Value: 6.99,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:51',
    Name: 'Value',
    Value: 6.99,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:52',
    Name: 'Value',
    Value: 6.74,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:53',
    Name: 'Value',
    Value: 6.61,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:54',
    Name: 'Value',
    Value: 6.48,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:55',
    Name: 'Value',
    Value: 6.24,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:56',
    Name: 'Value',
    Value: 6.23,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:57',
    Name: 'Value',
    Value: 6.11,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:58',
    Name: 'Value',
    Value: 5.85,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:26:59',
    Name: 'Value',
    Value: 5.61,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:01',
    Name: 'Value',
    Value: 5.48,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:01',
    Name: 'Value',
    Value: 5.22,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:02',
    Name: 'Value',
    Value: 4.98,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:03',
    Name: 'Value',
    Value: 4.85,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:04',
    Name: 'Value',
    Value: 4.6,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:05',
    Name: 'Value',
    Value: 4.34,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:06',
    Name: 'Value',
    Value: 4.21,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:07',
    Name: 'Value',
    Value: 3.96,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:08',
    Name: 'Value',
    Value: 3.83,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:09',
    Name: 'Value',
    Value: 3.58,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:10',
    Name: 'Value',
    Value: 3.45,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:11',
    Name: 'Value',
    Value: 3.19,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:12',
    Name: 'Value',
    Value: 3.05,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:13',
    Name: 'Value',
    Value: 2.81,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:14',
    Name: 'Value',
    Value: 2.69,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:15',
    Name: 'Value',
    Value: 2.56,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:16',
    Name: 'Value',
    Value: 2.42,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:17',
    Name: 'Value',
    Value: 2.28,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:18',
    Name: 'Value',
    Value: 2.03,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:19',
    Name: 'Value',
    Value: 1.89,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:20',
    Name: 'Value',
    Value: 1.75,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:21',
    Name: 'Value',
    Value: 1.6,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:22',
    Name: 'Value',
    Value: 1.36,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:23',
    Name: 'Value',
    Value: 1.22,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:24',
    Name: 'Value',
    Value: 1.09,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:25',
    Name: 'Value',
    Value: 0.94,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:26',
    Name: 'Value',
    Value: 0.82,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:27',
    Name: 'Value',
    Value: 0.8,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:28',
    Name: 'Value',
    Value: 0.68,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:29',
    Name: 'Value',
    Value: 0.55,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:31',
    Name: 'Value',
    Value: 0.55,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:31',
    Name: 'Value',
    Value: 0.29,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:32',
    Name: 'Value',
    Value: 0.41,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:33',
    Name: 'Value',
    Value: 0.27,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:34',
    Name: 'Value',
    Value: 0.15,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:35',
    Name: 'Value',
    Value: 0.13,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:36',
    Name: 'Value',
    Value: -0.11,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:37',
    Name: 'Value',
    Value: -0.11,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:38',
    Name: 'Value',
    Value: -0.24,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:39',
    Name: 'Value',
    Value: -0.37,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:40',
    Name: 'Value',
    Value: -0.49,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:41',
    Name: 'Value',
    Value: -0.49,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:42',
    Name: 'Value',
    Value: -0.74,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:43',
    Name: 'Value',
    Value: -0.74,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:44',
    Name: 'Value',
    Value: -0.86,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:45',
    Name: 'Value',
    Value: -0.97,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:46',
    Name: 'Value',
    Value: -1.09,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:47',
    Name: 'Value',
    Value: -1.21,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:48',
    Name: 'Value',
    Value: -1.44,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:49',
    Name: 'Value',
    Value: -1.55,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:51',
    Name: 'Value',
    Value: -1.68,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:51',
    Name: 'Value',
    Value: -1.69,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:52',
    Name: 'Value',
    Value: -1.8,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:53',
    Name: 'Value',
    Value: -2.03,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:54',
    Name: 'Value',
    Value: -2.03,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:55',
    Name: 'Value',
    Value: -2.15,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:56',
    Name: 'Value',
    Value: -2.15,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:57',
    Name: 'Value',
    Value: -2.27,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:58',
    Name: 'Value',
    Value: -2.26,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:27:59',
    Name: 'Value',
    Value: -2.38,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:00',
    Name: 'Value',
    Value: -2.39,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:01',
    Name: 'Value',
    Value: -2.5,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:02',
    Name: 'Value',
    Value: -2.48,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:03',
    Name: 'Value',
    Value: -2.59,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:04',
    Name: 'Value',
    Value: -2.59,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:05',
    Name: 'Value',
    Value: -2.59,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:06',
    Name: 'Value',
    Value: -2.59,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:07',
    Name: 'Value',
    Value: -2.46,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:08',
    Name: 'Value',
    Value: -2.45,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:09',
    Name: 'Value',
    Value: -2.21,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:11',
    Name: 'Value',
    Value: -2.19,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:11',
    Name: 'Value',
    Value: -2.18,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:12',
    Name: 'Value',
    Value: -2.05,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:13',
    Name: 'Value',
    Value: -1.92,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:14',
    Name: 'Value',
    Value: -1.68,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:15',
    Name: 'Value',
    Value: -1.56,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:16',
    Name: 'Value',
    Value: -1.43,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:17',
    Name: 'Value',
    Value: -1.06,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:18',
    Name: 'Value',
    Value: -0.92,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:19',
    Name: 'Value',
    Value: -0.68,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:20',
    Name: 'Value',
    Value: -0.3,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:21',
    Name: 'Value',
    Value: -0.05,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:22',
    Name: 'Value',
    Value: 0.07,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:23',
    Name: 'Value',
    Value: 0.33,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:24',
    Name: 'Value',
    Value: 0.47,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:25',
    Name: 'Value',
    Value: 0.83,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:26',
    Name: 'Value',
    Value: 1.09,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:27',
    Name: 'Value',
    Value: 1.23,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:28',
    Name: 'Value',
    Value: 1.48,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:29',
    Name: 'Value',
    Value: 1.73,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:30',
    Name: 'Value',
    Value: 1.86,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:31',
    Name: 'Value',
    Value: 2.11,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:32',
    Name: 'Value',
    Value: 2.24,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:33',
    Name: 'Value',
    Value: 2.37,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:34',
    Name: 'Value',
    Value: 2.49,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:35',
    Name: 'Value',
    Value: 2.62,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:36',
    Name: 'Value',
    Value: 2.76,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:37',
    Name: 'Value',
    Value: 2.89,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:38',
    Name: 'Value',
    Value: 3.14,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:39',
    Name: 'Value',
    Value: 3.14,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:41',
    Name: 'Value',
    Value: 3.38,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:41',
    Name: 'Value',
    Value: 3.52,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:42',
    Name: 'Value',
    Value: 3.64,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:43',
    Name: 'Value',
    Value: 3.77,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:44',
    Name: 'Value',
    Value: 3.9,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:45',
    Name: 'Value',
    Value: 4.03,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:46',
    Name: 'Value',
    Value: 4.02,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:47',
    Name: 'Value',
    Value: 4.03,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:48',
    Name: 'Value',
    Value: 4.15,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:49',
    Name: 'Value',
    Value: 4.15,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:50',
    Name: 'Value',
    Value: 4.03,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:51',
    Name: 'Value',
    Value: 4.16,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:52',
    Name: 'Value',
    Value: 4.04,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:53',
    Name: 'Value',
    Value: 3.92,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:54',
    Name: 'Value',
    Value: 4.03,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:55',
    Name: 'Value',
    Value: 3.91,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:56',
    Name: 'Value',
    Value: 3.79,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:57',
    Name: 'Value',
    Value: 3.79,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  },
  {
    DateTime: '2022-05-25 05:28:58',
    Name: 'Value',
    Value: 3.66,
    Description: 'Deaerator level control@@PV (mm)',
    percentage: null
  }
];
